<template>
  <div class="pb-3">
    <div class="dashboard__row-1">
      <div class="row-1__item-1">
        <!-- TICKET PRIORITY COUNT START -->
        <molecule-dashboard-container
          title="All Ticket (Priority)"
          :isLoading="isLoadingTicketPriority"
          class="mb-1"
          ><template #body>
            <div
              class="d-flex justify-content-between align-items-center w-100 height-ticket-priority"
            >
              <div class="position-relative">
                <div class="position-absolute ticket-priority__count">
                  <div class="d-flex flex-column align-items-center">
                    <label class="ticket-priority__text-count">{{
                      ticketPriorityCount
                    }}</label>
                    <label class="ticket-priority__text">Ticket</label>
                  </div>
                </div>
                <atom-doughnut-chart-v-2
                  radius="100%"
                  innerRadius="70%"
                  textCenter="TEST\\nyy"
                  :isTextInner="false"
                  :isShowTextCenterWhenHover="false"
                  :dataList="ticketPriorityList"
                  width="120px"
                  height="120px"
                ></atom-doughnut-chart-v-2>
              </div>
              <div class="ml-2">
                <div
                  v-for="({ value, name }, index) in ticketPriorityList"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <label class="ticket-priority__text-value">{{ value }}</label>
                  <label class="ticket-priority__text-name ml-1">{{
                    name
                  }}</label>
                </div>
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
        <!-- TICKET PRIORITY COUNT END -->

        <!-- TICKET STATUS COUNT START -->
        <molecule-dashboard-container
          title="All Ticket"
          icon="TagIcon"
          :isLoading="ticketStatusCount.isLoading"
          :isBgHeader="true"
          class="status-count__card mb-1"
        >
          <template #body>
            <div
              class="d-flex justify-content-around justify-content-md-between w-100 mt-1"
            >
              <div>
                <p class="text-status-count">Open</p>
                <p class="mb-0 text-count-open">{{ ticketStatusCount.open }}</p>
              </div>
              <div>
                <p class="text-status-count">In Progress</p>
                <p class="mb-0 text-count-in-progress">
                  {{ ticketStatusCount.inProgress }}
                </p>
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
        <!-- TICKET STATUS COUNT END -->
      </div>

      <!-- TICKET CRITICAL ENTRY START -->
      <div class="row-1__item-2 mb-1">
        <molecule-dashboard-container
          title="Ticket Critical Entry"
          :isLoading="isLoadingTicketCriticalEntry"
          :isHasBodyPadding="false"
          classHeaderLayout="d-lg-flex"
        >
          <template #body>
            <div class="container__body w-100 height-ticket-critical-entry">
              <div
                v-if="!ticketCriticalEntryList.length"
                class="d-flex flex-column align-items-center justify-content-center h-100"
              >
                <feather-icon icon="CloudOffIcon" class="icon_folder" />
                No Critical Entry
              </div>
              <div
                v-for="(entry, index) of ticketCriticalEntryList"
                :key="index"
                class="w-100"
              >
                <div
                  class="d-md-flex w-100 justify-content-between entry__item py-1"
                  @click="clickRowTicketCriticalEntry(entry)"
                >
                  <div class="d-flex flex-column col-12 col-md-4 pl-0">
                    <label class="text-company">{{ entry.companyName }}</label>
                    <label class="text-idc">{{
                      `${contractIdLabel}: ${entry.idcId || "-"}`
                    }}</label>
                    <label class="text-idc">{{
                      entry.idLabel || entry.id || ""
                    }}</label>
                  </div>
                  <div
                    class="d-flex justify-content-between col-12 col-md-8 px-0 mt-1 mt-md-0"
                  >
                    <div class="d-flex flex-column">
                      <label class="text-normal"> {{ entry.subject }}</label>
                      <label class="text-normal"> {{ entry.detail }}</label>
                    </div>
                    <div class="d-flex flex-column align-items-end">
                      <label class="text-date">{{ entry.date }}</label>
                      <div class="d-flex align-items-center">
                        <div :id="'entry-date-' + index" class="d-flex">
                          <feather-icon
                            icon="InfoIcon"
                            size="12"
                            class="alert__icon alert__icon-info"
                          />
                        </div>
                        <b-tooltip
                          :target="'entry-date-' + index"
                          placement="left"
                          boundary="window"
                          variant="primary"
                        >
                          <div class="description__container">
                            <div>Created date</div>
                          </div>
                        </b-tooltip>
                        <label class="text-time">{{ entry.time }}</label>
                      </div>
                      <b-badge
                        variant="light-dark"
                        class="badge--width text-size-12"
                      >
                        {{ entry.siteName || "Site Not Found" }}
                      </b-badge>
                    </div>
                  </div>
                </div>

                <hr class="my-0" />
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
      </div>
      <!-- TICKET CRITICAL ENTRY END -->
    </div>

    <!-- TICKET ESCALATION START -->
    <molecule-dashboard-container
      title="Ticket Escalation"
      :isLoading="isLoadingTicketEscalation"
      :isHasBodyPadding="false"
      class="w-100 mb-1"
    >
      <template #body>
        <div class="container__body w-100">
          <div
            v-if="!ticketEscalationList.length"
            class="d-flex flex-column align-items-center justify-content-center h-100"
          >
            <feather-icon icon="CloudOffIcon" class="icon_folder" />
            No Ticket Escalation
          </div>
          <div
            v-for="(ticketEscalation, index) of ticketEscalationList"
            :key="index"
            class="w-100"
          >
            <div
              class="d-md-flex w-100 justify-content-between entry__item py-1"
              @click="clickRowTicketEscalation(ticketEscalation)"
            >
              <div
                class="d-flex justify-content-between col-12 col-md-2 px-0 pr-md-1"
              >
                <div class="d-flex flex-column">
                  <label class="text-company">{{
                    ticketEscalation.companyName
                  }}</label>
                  <label class="text-idc">{{
                    `${contractIdLabel}: ${ticketEscalation.idcId || "-"}`
                  }}</label>
                  <label class="text-idc">{{
                    ticketEscalation.idLabel || ticketEscalation.id || ""
                  }}</label>
                </div>
              </div>

              <div
                class="d-flex flex-column col-12 col-md-3 px-0 pr-md-1 mt-1 mt-md-0"
              >
                <label class="text-normal">
                  {{ `Subject: ${ticketEscalation.subject}` }}
                </label>
                <label v-if="ticketEscalation.lastReply" class="text-normal">
                  {{ `${ticketEscalation.lastReply}` }}
                </label>
              </div>

              <div
                class="d-flex flex-column col-12 col-md-3 px-0 pr-md-1 mt-1 mt-md-0"
              >
                <div class="d-flex">
                  <label class="text-normal">
                    {{ `Escalate to Level: ${ticketEscalation.level}` }}
                  </label>
                </div>
                <label v-if="ticketEscalation.escalateBy" class="text-normal">
                  {{ `By: ${ticketEscalation.escalateBy}` }}
                </label>
                <label v-if="ticketEscalation.current" class="text-normal">
                  {{ `Current: ${ticketEscalation.current}` }}
                </label>
              </div>

              <div
                class="d-flex justify-content-between align-items-start col-12 col-md-3 px-0 mt-1 mt-md-0"
              >
                <b-badge
                  pill
                  :variant="getVariantForStatus(ticketEscalation.status)"
                  >{{ getStatus(ticketEscalation.status) }}</b-badge
                >
                <div class="d-flex flex-column align-items-end">
                  <label class="text-date">{{ ticketEscalation.date }}</label>
                  <div class="d-flex align-items-center">
                    <div :id="'ticket-escalated-date-' + index" class="d-flex">
                      <feather-icon
                        icon="InfoIcon"
                        size="12"
                        class="alert__icon alert__icon-info"
                      />
                    </div>
                    <b-tooltip
                      :target="'ticket-escalated-date-' + index"
                      placement="left"
                      boundary="window"
                      variant="primary"
                    >
                      <div class="description__container">
                        <div>Escalated date</div>
                      </div>
                    </b-tooltip>
                    <label class="text-time">{{ ticketEscalation.time }}</label>
                  </div>
                  <b-badge
                    variant="light-dark"
                    class="badge--width text-size-12"
                  >
                    {{ ticketEscalation.siteName || "Site Not Found" }}
                  </b-badge>
                </div>
              </div>
            </div>

            <hr class="my-0" />
          </div>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- TICKET ESCALATION END -->

    <!-- TICKET RECENT CHANGE START -->
    <molecule-dashboard-container
      title="Ticket Recent Change"
      :isLoading="isLoadingTicketRecentChange"
      :isHasBodyPadding="false"
      class="w-100 mb-1"
    >
      <template #body>
        <div class="container__body w-100">
          <div
            v-if="!ticketRecentChangeList.length"
            class="d-flex flex-column align-items-center justify-content-center h-100"
          >
            <feather-icon icon="CloudOffIcon" class="icon_folder" />
            No Recent Change
          </div>
          <div
            v-for="(recentChange, index) of ticketRecentChangeList"
            :key="index"
            class="w-100"
          >
            <div
              class="d-md-flex w-100 justify-content-between entry__item py-1"
              @click="clickRowTicketRecentChange(recentChange)"
            >
              <div
                class="d-flex justify-content-between col-12 col-md-4 px-0 pr-md-1"
              >
                <div class="d-flex flex-column">
                  <label class="text-company">{{
                    recentChange.companyName
                  }}</label>
                  <label class="text-idc">{{
                    `${contractIdLabel}: ${recentChange.idcId || "-"}`
                  }}</label>
                  <label class="text-idc">{{
                    recentChange.idLabel || recentChange.id || ""
                  }}</label>
                </div>
                <div
                  class="priority-container"
                  :class="`priority__${recentChange.priority.toLowerCase()}`"
                >
                  {{ recentChange.priority }}
                </div>
              </div>

              <div
                class="d-md-flex justify-content-between col-12 col-md-8 px-0 mt-1 mt-md-0"
              >
                <div class="d-flex flex-column col-12 col-md-8 px-0">
                  <label class="text-normal">
                    {{ `Subject: ${recentChange.subject}` }}
                  </label>
                  <label
                    v-if="recentChange.staff && recentChange.activity"
                    class="text-normal"
                  >
                    {{ `${recentChange.staff}: ${recentChange.activity}` }}
                  </label>
                </div>

                <div
                  class="d-flex justify-content-between align-items-start col-12 col-md-4 px-0 mt-1 mt-md-0"
                >
                  <b-badge
                    pill
                    :variant="getVariantForStatus(recentChange.status)"
                    >{{ getStatus(recentChange.status) }}</b-badge
                  >
                  <div class="d-flex flex-column align-items-end">
                    <label class="text-date">{{ recentChange.date }}</label>
                    <div class="d-flex align-items-center">
                      <div :id="'recent-change-date-' + index" class="d-flex">
                        <feather-icon
                          icon="InfoIcon"
                          size="12"
                          class="alert__icon alert__icon-info"
                        />
                      </div>
                      <b-tooltip
                        :target="'recent-change-date-' + index"
                        placement="left"
                        boundary="window"
                        variant="primary"
                      >
                        <div class="description__container">
                          <div>Updated date</div>
                        </div>
                      </b-tooltip>
                      <label class="text-time">{{ recentChange.time }}</label>
                    </div>
                    <b-badge
                      variant="light-dark"
                      class="badge--width text-size-12"
                    >
                      {{ recentChange.siteName || "Site Not Found" }}
                    </b-badge>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-0" />
          </div>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- TICKET RECENT CHANGE END -->

    <!-- TICKET NEW ENTRY STATISTICS START -->
    <!-- <molecule-dashboard-container
      title="Ticket New Entry Statistics"
      :isLoading="isLoadingTicketEntryStat"
      :isHasBodyPadding="false"
    >
      <template #header>
        <b-button-group class="mt-1 mt-md-0 width-sm-100">
          <b-button
            v-for="(time, index) of ticketEntryStatTimeList"
            :key="index"
            :variant="getVariantEntryTime(time)"
            @click="onChangeTicketEntryStatTime(time)"
            class="height-button-group"
            >{{ time }}</b-button
          >
        </b-button-group>
      </template>
      <template #body>
        <div class="container__body w-100 pb-2 height-graph">
          <atom-multi-line-chart
            :timestampList="ticketEntryStatTimestampList"
            :dataList="ticketEntryStatDataList"
          ></atom-multi-line-chart>
        </div>
      </template>
    </molecule-dashboard-container> -->
    <!-- TICKET NEW ENTRY STATISTICS END -->
  </div>
</template>

<script>
import { BBadge, BButtonGroup, BButton, BTooltip } from "bootstrap-vue"
import MoleculeDashboardContainer from "@/components/molecules/MoleculeDashboardContainer.vue"
import AtomMultiLineChart from "@/components/atoms/graphs/AtomMultiLineChart.vue"
import AtomDoughnutChartV2 from "@/components/atoms/graphs/AtomDoughnutChartV2.vue"
import mixins from "@/mixins"

export default {
  name: "OrganismExecutiveDashboard",
  components: {
    BBadge,
    BButtonGroup,
    BButton,
    MoleculeDashboardContainer,
    AtomMultiLineChart,
    AtomDoughnutChartV2,
    BTooltip,
  },
  mixins: [mixins],
  props: {
    ticketStatusCount: {
      type: Object,
      required: true,
    },
    isLoadingTicketPriority: {
      type: Boolean,
      required: true,
    },
    ticketPriorityCount: {
      type: Number,
      required: true,
    },
    ticketPriorityList: {
      type: Array,
      required: true,
    },
    isLoadingTicketCriticalEntry: {
      type: Boolean,
      required: true,
    },
    ticketCriticalEntryList: {
      type: Array,
      required: true,
    },
    isLoadingTicketEscalation: {
      type: Boolean,
      required: true,
    },
    ticketEscalationList: {
      type: Array,
      required: true,
    },
    isLoadingTicketRecentChange: {
      type: Boolean,
      required: true,
    },
    ticketRecentChangeList: {
      type: Array,
      required: true,
    },
    isLoadingTicketEntryStat: {
      type: Boolean,
      required: true,
    },
    ticketEntryStatTimeList: {
      type: Array,
      required: true,
    },
    ticketEntryStat: {
      type: Object,
      required: true,
    },
  },
  emits: ["changeTicketEntryStatTime"],
  data() {
    return {
      // TICKET NEW ENTRY STATISTICS
      ticketEntryStatTimestampList: [],
      ticketEntryStatDataList: [],
      selectTicketEntryStatTime: "1M",
    }
  },
  async mounted() {
    await this.setTicketEntryStatData()
  },
  watch: {
    ticketEntryStat: {
      deep: true,
      handler() {
        this.setTicketEntryStatData()
      },
    },
  },
  methods: {
    setTicketEntryStatData() {
      this.ticketEntryStatTimestampList =
        this.ticketEntryStat.timestampList ?? []
      this.ticketEntryStatDataList = this.ticketEntryStat.dataList ?? []
    },

    clickRowTicketCriticalEntry(entry) {
      this.$router.push(`/internal/web-portal/ticket/${entry.id}`)
    },

    clickRowTicketEscalation(ticketEscalation) {
      this.$router.push(`/internal/web-portal/ticket/${ticketEscalation.id}`)
    },

    clickRowTicketRecentChange(recentChange) {
      this.$router.push(`/internal/web-portal/ticket/${recentChange.id}`)
    },

    onChangeTicketEntryStatTime(time) {
      this.selectTicketEntryStatTime = time
      this.$emit("changeTicketEntryStatTime", this.selectTicketEntryStatTime)
    },

    getVariantForStatus(status) {
      switch (status) {
        case "OPENED":
          return "light-primary"

        case "IN_PROGRESS":
          return "light-warning"

        case "CLOSED":
          return "light-secondary"
      }
    },

    getStatus(status) {
      switch (status) {
        case "OPENED":
          return "Opened"

        case "IN_PROGRESS":
          return "In Progress"

        case "CLOSED":
          return "Closed"
      }
    },

    getVariantEntryTime(time) {
      return this.selectTicketEntryStatTime === time
        ? "outline-primary"
        : "outline-secondary"
    },
  },
}
</script>

<style lang="scss" scoped>
.alert__icon-info {
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
  }
}

.alert__icon-level {
  color: #ff9f43;
  margin-left: 12px;
  &:hover {
    cursor: pointer;
  }
}

.entry__item:hover {
  background-color: #7367f00a;
  cursor: pointer;
}
.textbox__warning-value--style {
  color: #ff9f43;
  text-align: center;
}

.status-count__card {
  min-width: 150px;
  width: 100%;
}

.text-idc {
  color: #b9b9c3;
  font-weight: 400;
}

.text-normal {
  color: #6e6b7b;
  font-weight: 400;
  display: block;
  overflow-wrap: break-word;
  word-break: break-word;
}

.text-date {
  color: #6e6b7b;
}

.text-time {
  color: #b9b9c3;
  font-weight: 400;
  margin-bottom: 0;
  margin-left: 6px;
}

.text-status-count {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 4px;
}

.text-count-open {
  text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  color: #7367f0;
  font-weight: 700;
  font-size: 24px;
}

.badge--width {
  margin-top: 3px;
}

.text-count-in-progress {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 24px;
}

.dashboard__row-1 {
  .row-1__item-1 {
    width: 100%;
  }

  .row-1__item-2 {
    width: 100%;
  }
}

.width-graph {
  width: 100%;
}

.height-button-group {
  height: 34px;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 10px 14px;
}

.ticket-priority__count {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 100%;
  width: 100%;
}

.ticket-priority__text-count {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.ticket-priority__text {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
}

.ticket-priority__text-value,
.ticket-priority__text-name {
  color: #5e5873;
  font-weight: 700;
  font-size: 14px;
}
.ticket-priority__text-name {
  font-weight: 500;
  width: 62px;
}

.container__body {
  height: 400px;
  overflow-y: auto;
  padding: 0 14px;
}

.height-ticket-priority {
  height: 148px;
}

.priority__critical {
  font-weight: 600;
  font-size: 14px;
  color: #ea5455;
}

.priority__high {
  font-size: 14px;
  color: #ea5455;
}

.priority__medium {
  font-size: 14px;
  color: #ff9f43;
}

.priority__low {
  font-size: 14px;
  color: #28c76f;
}

.width-sm-100 {
  width: 100%;
}

.height-graph {
  height: 315px;
}

.icon_folder {
  width: 70px;
  height: 70px;
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .dashboard__row-1 {
    display: flex;

    .row-1__item-1 {
      width: 262px;
    }

    .row-1__item-2 {
      padding-left: 14px;
      width: calc(100% - 262px);
    }
  }

  .height-ticket-critical-entry {
    height: 300px;
  }

  .width-sm-100 {
    width: auto;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .height-lg-34px {
    height: 34px;
  }
}

// X-Large devices (larger desktops, 1140px and up)
@media (min-width: 1400px) {
  .width-graph {
    width: 50%;
  }

  .p-xl-l-7px {
    padding-left: 7px;
  }

  .p-xl-r-7px {
    padding-right: 7px;
  }
}
</style>
